export enum ExistingCreditCard {
  No = 'n',
  Yes = 'y',
  LessThenSixMonth = '6m',
  FromSixMonthToOneYear = '6-12m',
  OverOneYear = '12m',
}

export enum EmploymentStatus {
  EmployedPrivateSector = 'js-employed private sector',
  EmployedGovernment = 'js-employed government',
  EmployedBPO = 'js-employed bpo',
  EmployedOFW = 'js-employed ofw',
  SelfEmployed = 'js-employed self',
  ForeignResident = 'js-foreign resident',
  Unemployed = 'js-unemployed',
  Retired = 'js-retired',
}
